export const createPagingArray = (total: number, pageSize: number) => {
    const length = total ? Math.ceil(total / pageSize) : 1;

    return Array.from({ length }, (v, k) => k + 1);
};
